import { Flex, Center, Box } from '@chakra-ui/react';
import { FinishedIcon, MessagingErrorIcon, MessagingPendingIcon } from '@halo/ui-chat-react';

export interface TransferStatusProps {
  status: 'pending' | 'success' | 'fail';
}

export function TransferStatus({ status }: TransferStatusProps) {
  const render = useMemo(() => {
    switch (status) {
      case 'success': {
        return (
          <>
            <Center fontSize="sm">
              <FinishedIcon />
            </Center>
            <Box fontSize="xs" fontWeight="medium">
              Success
            </Box>
          </>
        );
      }
      case 'fail': {
        return (
          <>
            <Center fontSize="sm">
              <MessagingErrorIcon />
            </Center>
            <Box fontSize="xs" fontWeight="medium">
              Failed
            </Box>
          </>
        );
      }
      default: {
        return (
          <>
            <Center fontSize="sm" style={{ animation: 'spin 3s linear infinite' }}>
              <MessagingPendingIcon />
            </Center>
            <Box fontSize="xs" fontWeight="medium">
              Pending
            </Box>
          </>
        );
      }
    }
  }, [status]);

  return (
    <Flex flex="1" gap="1" color="white">
      {render}
    </Flex>
  );
}
